export default "__VITE_ASSET__Cjugu1Eo__"